import { CloseButton, Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import SetPasswordFileForm from '../../forms/SetPasswordFileForm';
import styles from './styles.scoped.css';

export default function ModalSetPassword({ open, handledClose, handledDownload, isLoading }) {

  return(
    <Modal centered opened={open} size={'lg'} withCloseButton={false}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h5>Set Kata Sandi & Unduh Data</h5>
          <span onClick={handledClose}><CloseButton/></span>
        </div>
        <span>Untuk keamanan data, set kata sandi file yang akan Anda unduh terlebih dahulu.</span>
        <SetPasswordFileForm
          handledClose={handledClose}
          handleSubmit={(val) => handledDownload(val)}
          isLoading={isLoading}/>
      </div>
    </Modal>
  );
}

ModalSetPassword.propTypes = {
  handledClose: PropTypes.func,
  handledDownload: PropTypes.func,
  isLoading: PropTypes.bool,
  open: PropTypes.bool,
};
